import styled from "styled-components";

const Pencil = styled.i.attrs({
  className: "fa fa-pencil"
})``;

export default Pencil;
